import * as React from 'react'

import { MobXProviderContext, observer } from 'mobx-react'

import { LocationType, PermitFieldType } from '~/client/graph/types.generated'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '~/client/src/shared/components/shadcn-ui/popover'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import type InitialState from '~/client/src/shared/stores/InitialState'

import ResourceTypeSelectionContent from '../../../../WorkflowFieldRestriction/variants/ResourceTypeSelectionContent'
import { useResourceValueSelection } from './useResourceValueSelection'

interface IProps {
  selectedIds: string[]
  isEditMode: boolean
  restrictedLocationIds: string[]
  restrictedLocationTypes: LocationType[]
  configuredFieldType?: PermitFieldType

  onChange(optionIds: string[]): void
}

export default observer(ValuesSelector)

function ValuesSelector({
  selectedIds,
  isEditMode,
  restrictedLocationTypes,
  restrictedLocationIds,
  configuredFieldType,
  onChange,
}: IProps) {
  const { state } = React.useContext(MobXProviderContext) as {
    state: InitialState
  }
  const [isOpen, setIsOpen] = React.useState(false)
  const { resourceTypeId, resourceLabel, recordPredicate } =
    useResourceValueSelection({
      fieldType: configuredFieldType,
      restrictedIds: restrictedLocationIds,
      restrictedTypes: restrictedLocationTypes,
      selectedIds,
    })

  const handleApply = (ids: string[]) => {
    onChange(ids)
    setIsOpen(false)
  }

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger
        nativeButton={false}
        disabled={!isEditMode}
        render={
          <div className="pointer text large blue-highlight pa10 ml15 tw:w-fit" />
        }
      >
        + {Localization.translator.addOption}
      </PopoverTrigger>
      <PopoverContent
        side="bottom"
        align="start"
        collisionAvoidance={{ fallbackAxisSide: 'none' }}
        className="tw:w-[400px] tw:overflow-hidden tw:p-0"
      >
        <ResourceTypeSelectionContent
          resourceTypeId={resourceTypeId}
          projectId={state.activeProject?.id}
          resourceLabel={resourceLabel}
          selectedIds={selectedIds}
          recordPredicate={recordPredicate}
          allowEmptySelection={true}
          onApply={handleApply}
          onClose={() => setIsOpen(false)}
        />
      </PopoverContent>
    </Popover>
  )
}
